var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React, { useContext } from "react";
import { Modal, ModalContent, ModalBody, Input, FormControl, FormLabel, VStack, HStack, ModalOverlay, ModalHeader, Switch, Box, Select, Button, Flex, } from "@reverb-ui/react";
import { Controller, useForm, useWatch } from "react-hook-form";
import { RequiredIndicator } from "../components/required-indicator";
import { IconButton } from "@reverb-ui/react";
import { ArrowLeft } from "@reverb-ui/icons-react";
import { AuthContext } from "@/shared/presentation/context-api/providers/auth";
import { UtilContext } from "@/shared/presentation/context-api/providers/util";
import { FirstAccessContext } from "@/shared/presentation/context-api/providers/first-access";
import { useHistory } from "react-router";
import { DocumentTypesCode } from "@/shared/domain/entities/generic-type";
export var Talent = function (_a) {
    var entityDatasource = _a.entityDatasource;
    var _b = useForm(), handleSubmit = _b.handleSubmit, register = _b.register, control = _b.control, errors = _b.formState.errors, clearErrors = _b.clearErrors, reset = _b.reset;
    var _c = useContext(UtilContext), countries = _c.countries, documentTypes = _c.documentTypes;
    var _d = useContext(AuthContext), user = _d.user, renewToken = _d.renewToken;
    var _e = useContext(FirstAccessContext), isLoading = _e.isLoading, createTalent = _e.createTalent;
    var formValues = useWatch({ control: control });
    var history = useHistory();
    var submit = function (values) { return __awaiter(void 0, void 0, void 0, function () {
        var passwordDefault, name, preferredName, email, locationId, usePreferredName, talent, talentRockId;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    passwordDefault = "Pass@123";
                    name = values.name, preferredName = values.preferredName, email = values.emailUser, locationId = values.location.value, usePreferredName = values.usePreferredName;
                    return [4 /*yield*/, createTalent({
                            name: name,
                            document: (_a = user === null || user === void 0 ? void 0 : user.entity) === null || _a === void 0 ? void 0 : _a.document,
                            documentTypeId: getHashDocumentTypeId(),
                            preferredName: getPreferredName(usePreferredName, preferredName),
                            locationId: locationId,
                            user: {
                                email: email,
                                password: passwordDefault,
                            },
                        })];
                case 1:
                    talent = _b.sent();
                    talentRockId = talent === null || talent === void 0 ? void 0 : talent.rockId;
                    if (!talentRockId) return [3 /*break*/, 3];
                    return [4 /*yield*/, entityDatasource.updateEntity(talentRockId, {
                            name: name,
                            preferredName: preferredName,
                        })];
                case 2:
                    _b.sent();
                    window.open(process.env.GTN_URL, "_blank");
                    renewToken().then(function () {
                        history.push("/home");
                    });
                    _b.label = 3;
                case 3:
                    handleClose();
                    return [2 /*return*/];
            }
        });
    }); };
    var getPreferredName = function (usePreferredName, preferredName) {
        if (!usePreferredName) {
            return undefined;
        }
        return preferredName;
    };
    var getHashDocumentTypeId = function () {
        var hashDocumentTypeId = documentTypes.filter(function (documentType) { return documentType.code === DocumentTypesCode.Hash; })[0];
        return hashDocumentTypeId.id;
    };
    var nameValidator = {
        required: {
            value: true,
            message: "Name is required",
        },
    };
    var requiredValidator = {
        required: true,
    };
    var handleClose = function () {
        reset();
        clearErrors();
    };
    return (React.createElement(Modal, { isOpen: true, onClose: function () { return null; }, size: "2xl" },
        React.createElement(ModalOverlay, null),
        React.createElement(ModalContent, null,
            React.createElement(ModalHeader, null,
                React.createElement(IconButton, { variant: "ghost", "aria-label": "Go back", icon: React.createElement(ArrowLeft, { color: "gray.500", size: "lg", variant: "solid" }), onClick: function () { return history.push("/first-access"); } })),
            React.createElement(ModalBody, null,
                React.createElement(Box, { w: "full" },
                    React.createElement("form", null,
                        React.createElement(VStack, { spacing: 8, fontSize: "md" },
                            React.createElement(HStack, { w: "full", spacing: 8 },
                                React.createElement(FormControl, { isRequired: true, isInvalid: !!errors.name },
                                    React.createElement(FormLabel, { requiredIndicator: React.createElement(RequiredIndicator, null) }, "Name"),
                                    React.createElement(Input, __assign({}, register("name", nameValidator)))),
                                React.createElement(FormControl, { isRequired: true },
                                    React.createElement(FormLabel, { requiredIndicator: React.createElement(RequiredIndicator, null) }, "Email"),
                                    React.createElement(Input, __assign({ isDisabled: true }, register("emailUser", {
                                        value: user === null || user === void 0 ? void 0 : user.email,
                                    }))))),
                            React.createElement(HStack, { w: "full", spacing: 8 },
                                React.createElement(FormControl, { display: "flex", alignItems: "center" },
                                    React.createElement(FormLabel, { htmlFor: "email-alerts", mb: "0" }, "Uses a preferred name"),
                                    React.createElement(Switch, __assign({}, register("usePreferredName")))),
                                formValues.usePreferredName && (React.createElement(FormControl, null,
                                    React.createElement(FormLabel, { requiredIndicator: React.createElement(RequiredIndicator, null), fontSize: "sm" }, "Preferred name"),
                                    React.createElement(Input, __assign({}, register("preferredName", nameValidator)))))),
                            React.createElement(HStack, { w: "full", alignItems: "start", spacing: 8 },
                                React.createElement(FormControl, { isRequired: true, width: "xs" },
                                    React.createElement(FormLabel, { requiredIndicator: React.createElement(RequiredIndicator, null) }, "Location"),
                                    React.createElement(Controller, { control: control, name: "location", rules: requiredValidator, render: function (_a) {
                                            var field = _a.field;
                                            return (React.createElement(Select, __assign({}, field, { options: countries.map(function (_a) {
                                                    var description = _a.description, id = _a.id;
                                                    return ({
                                                        label: description,
                                                        value: id,
                                                    });
                                                }) })));
                                        } }))))),
                    React.createElement(Flex, { justifyContent: "end", pt: 8, pb: 3 },
                        React.createElement(Flex, null,
                            React.createElement(Button, { colorScheme: "blue", onClick: handleSubmit(submit), isDisabled: !!isLoading }, "Next"))))))));
};
